<template>
  <div>
    <PageAllow
      controller="StockIns"
      :action="isNew || stockInitialize ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <ValidationObserver ref="observer">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{
                  $t(isNew || stockInitialize ? "CRUD.newInfo" : "CRUD.info", [
                    $t("StockOrderIN.ObjectName"),
                  ])
                }}
                <v-chip
                  v-if="stock_in.cancel_flg"
                  small
                  label
                  outlined
                  class="ms-4 mt-1"
                  color="danger"
                >
                  {{ $t("CRUD.cancelled") }}
                </v-chip>
                <v-chip
                  v-if="!isNew && !stockInitialize"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="stock_in.status | stockOrderINStatusColor"
                  :text-color="stock_in.status | stockOrderINStatusTextColor"
                  >{{ stock_in.status | stockOrderINStatusText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="
                      (isNew || stockInitialize) &&
                      $permission.permissionAllow('StockIns', 'add')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderIN.actions.submitStockIN") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'edit' &&
                      $permission.permissionAllow('StockIns', 'edit')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderIN.actions.editStockINSubmit") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'in' &&
                      $permission.permissionAllow('StockIns', 'in')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doStockIN()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderIN.actions.stockIn") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'in' &&
                      $permission.permissionAllow('StockIns', 'in') &&
                      stock_in.type == 2 &&
                      stock_in.actions &&
                      stock_in.actions.in_complete_and_loss
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doStockIN('inCompleteAndLoss')"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("StockOrderIN.actions.inCompleteAndLoss") }}
                  </v-btn>
                </v-sheet>
                <StockOrderINActions
                  v-if="isView"
                  :stock_in="stock_in"
                  @in="mode = 'in'"
                  @edit="mode = 'edit'"
                  @done="$router.push('/stock-orders-in')"
                  :showLogistic="
                    $permission.permissionAllow(
                      'Requisitions',
                      'getRequisitionLogistic'
                    ) && stock_in.type == 2
                  "
                  showEdit
                  showComplete
                  detail-mode
                  showApprove
                  showCancel
                  showPrint
                />
              </v-card-title>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_in_code") }}
                      {{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.stock_order_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.ext_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_in.ext_code }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_in_obj_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.obj_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.created | formatTime }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="mode == 'edit'"
                      class="my-n2"
                      v-model="stock_in.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_in.actual_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.finish_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_in.finish_time | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_in_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-select
                      v-if="isNew"
                      v-model="stock_in.type"
                      :items="
                        $consts.stock_in_order.types.filter(
                          (element) =>
                            element.value == 1 ||
                            element.value == 11 ||
                            element.value == 12 ||
                            element.value == 13
                        )
                      "
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    >
                    </v-select>
                    <span v-else>
                      {{ stock_in.type | stockOrderINTypesText }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherStock
                      v-if="isNew"
                      noLabel
                      v-model="stockSelected"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      :stock-types="[0]"
                    />
                    <span v-else>
                      {{
                        stock_in && stock_in.stock ? stock_in.stock.name : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" class="d-none d-md-inline" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-model="stock_in.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12" v-if="isNew">
                  <v-card
                    v-if="stock_in.type == 1"
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.shop", [$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherShop
                      no-label
                      v-model="shopSelected"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      isNotPsi
                    />
                  </v-card>
                  <v-card
                    v-if="stock_in.type == 11"
                    class="pa-2 text-no-wrap d-flex"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.supplier")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherSupplier
                      noLabel
                      v-model="supplierSelected"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && stock_in.type == 11">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.supplier")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.obj_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  class="d-inline d-md-none"
                  v-if="isNew"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-model="stock_in.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !stockInitialize">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.creater")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.creater_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-inline d-md-none"
                  v-if="!isNew && !stockInitialize"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.operater_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-inline d-md-none"
                  v-if="!isNew && !stockInitialize"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.executer_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.executer_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && stock_in.type == 1">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t("StockOrderIN.Fields.shop_user_name", [
                          $consts.shopName(),
                        ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_in && stock_in.shop && stock_in.shop.shop_user
                        ? stock_in.shop.shop_user.name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && stock_in.type == 1">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.receiver_tel")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_in && stock_in.shop && stock_in.shop.shop_user
                        ? stock_in.shop.shop_user.tel
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-none d-md-inline"
                  v-if="!isNew && !stockInitialize"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.operater_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="!isNew && stock_in.type == 1"
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t("StockOrderIN.Fields.shop_address", [
                          $consts.shopName(),
                        ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in && stock_in.shop ? stock_in.shop.address : "" }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  class="d-none d-md-inline"
                  v-if="!isNew && !stockInitialize"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.executer_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_in.executer_name }}
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-if="
                    stock_in.type == 2 &&
                    settings &&
                    settings.requisition_express_price == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.express_price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("Global.money") }}
                      {{
                        stock_in && stock_in.requisition
                          ? stock_in.requisition.express_price
                          : "" | formatMoneyFloor
                      }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="!stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("StockOrderIN.Fields.attachment")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="savable || (isStockIN && stock_in.order_code) || edit_attachment"
                      v-model="stock_in.attachment"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else style="overflow-wrap: break-word;white-space: pre-wrap">
                      {{ stock_in.attachment }}
                    </span>
                    <v-btn
                      v-if="!savable &&!edit_attachment"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="edit_attachment = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("StockOrderOUT.actions.editAttachment") }}
                    </v-btn>
                    <v-btn
                      v-if="edit_attachment"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="saveAttachment()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <!-- 附件  -->
                <v-col cols="12" sm="12" md="12" v-if="!stockInitialize">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text"
                      >{{ $t("StockOrderIN.Fields.attachment_images")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 上传图片集 -->
                    <span class="ml-4">
                      <v-card
                        height="160"
                        width="240"
                        v-if="album && album.length > 0"
                      >
                        <v-carousel
                          hide-delimiters
                          cycle
                          height="160"
                          width="240"
                        >
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip
                              right
                              v-if="(savable || isStockIN) && item"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="imgs_file"
                        v-show="savable || isStockIN"
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :hint="$t('Material.imgsHint')"
                        :rules="imgsRules"
                        v-model="imgs_file"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew && !stockInitialize">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("StockOrderIN.actions.activities") }}
                </v-tab>
                <v-tab
                  @click.stop="
                    tab = 1;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                  v-if="
                    stock_in.type == 11 ||
                    stock_in.type == 3 ||
                    stock_in.examine ||
                    stock_in.type == 4 ||
                    stock_in.type == 1
                  "
                >
                  {{ $t("StockOrderIN.actions.relations") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="stock_in_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card
                    flat
                    v-if="
                      stock_in.type == 11 ||
                      stock_in.examine ||
                      stock_in.type == 4 ||
                      stock_in.type == 1
                    "
                  >
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          small
                          label
                          :color="item.status | purchaseStatusColor"
                          :text-color="item.status | purchaseStatusTextColor"
                          v-if="item.controller == 'Purchases'"
                        >
                          {{ item.status | purchaseStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          :color="item.status | billFlgsColor"
                          :text-color="item.status | billFlgsTextColor"
                          v-else-if="item.controller == 'Receipt'"
                        >
                          {{ item.status | billFlgsText }}
                        </v-chip>
                        <v-chip
                          v-if="item.controller == 'ReturnOrders'"
                          small
                          label
                          :color="item.status | returnOrderStatusColor"
                          :text-color="item.status | returnOrderStatusTextColor"
                          >{{ item.status | returnOrderStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.controller == 'Orders'"
                          small
                          label
                          :color="item.status | orderStatusColor"
                          :text-color="item.status | orderStatusTextColor"
                          >{{ item.status | orderStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.controller == 'ProductionPlans'"
                          small
                          label
                          class="ms-4 mt-1"
                          :color="item.status | productionPlansStatusColor"
                          :text-color="
                            item.status | productionPlansStatusTextColor
                          "
                          >{{ item.status | productionPlansStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          class="ms-4 mt-1"
                          :color="item.is_examined | examineStatusColor"
                          :text-color="
                            item.is_examined | examineStatusTextColor
                          "
                          v-else-if="item.controller == 'Examines'"
                          >{{ item.is_examined | examineStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.cancel_flg"
                          small
                          label
                          outlined
                          color="danger"
                          class="ms-1 my-n1"
                          >{{ $t("CRUD.cancelled") }}
                        </v-chip>
                      </template>
                      <template v-slot:item.identify_code="{ item }">
                        <span class="text-no-wrap">
                          <a
                            v-if="item.controller == 'ReturnOrders'"
                            @click="$router.push('/return-orders/' + item.id)"
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-if="item.controller == 'Orders'"
                            @click="$router.push('/orders/' + item.id)"
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-if="item.controller == 'Receipt'"
                            @click="$router.push('/receipts/' + item.id)"
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-if="item.controller == 'FinanceBills'"
                            @click="
                              $router.push('/finance-bills-purchase/' + item.id)
                            "
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-else-if="item.controller == 'Purchases'"
                            @click="
                              $router.push('/purchases/detail/' + item.id)
                            "
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-if="item.controller == 'Examines'"
                            @click="$router.push('/examines/' + item.id)"
                          >
                            {{ item.identify_code }}
                          </a>
                          <span v-if="item.controller == 'ProductionPlans'">
                            {{ item.identify_code }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.identify_name="{ item }">
                        <span class="text-no-wrap">
                          <span v-if="item.controller == 'Receipt'">
                            {{ item.identify_name }}
                            <v-chip
                              v-if="item.all_loss_flg"
                              x-small
                              label
                              outlined
                              color="danger"
                              >{{ $t("CRUD.cancelled") }}
                            </v-chip>
                          </span>
                          <span v-else-if="item.controller == 'ReturnOrders'">
                            {{ item.identify_name }}
                          </span>
                          <span v-else-if="item.controller == 'Orders'">
                            {{ item.identify_name }}
                          </span>
                          <span v-else-if="item.controller == 'FinanceBills'">
                            {{ item.identify_name }}
                          </span>
                          <span v-else-if="item.controller == 'Purchases'">
                            {{ item.identify_name }}
                          </span>
                          <span v-else-if="item.controller == 'Examines'">
                            {{ item.identify_name }}
                          </span>
                          <span
                            v-else-if="item.controller == 'ProductionPlans'"
                          >
                            {{ item.identify_name }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="
                            $permission.permissionAllow(item.controller, 'view')
                          "
                          small
                          outlined
                          color="info"
                          class="px-2 me-2"
                          :href="'/#/' + item.identify + '/' + item.id"
                        >
                          <v-icon x-small class="pe-1">fa-align-left</v-icon>
                          {{ $t("Opt.details") }}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card flat v-else-if="stock_in.type == 3">
                    <v-data-table
                      :headers="relationsStockTakeHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          small
                          label
                          :color="item.status | purchaseStatusColor"
                          :text-color="item.status | purchaseStatusTextColor"
                          v-if="item.controller == 'Purchases'"
                        >
                          {{ item.status | purchaseStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          :color="item.status | billFlgsColor"
                          :text-color="item.status | billFlgsTextColor"
                          v-else-if="item.controller == 'Receipt'"
                        >
                          {{ item.status | billFlgsText }}
                        </v-chip>
                        <v-chip
                          v-if="item.cancel_flg"
                          small
                          label
                          outlined
                          color="danger"
                          class="ms-1 my-n1"
                          >{{ $t("CRUD.cancelled") }}
                        </v-chip>
                      </template>
                      <template v-slot:item.relations_name>
                        {{ $t("StockTakeOrders.ObjectName") }}
                      </template>
                      <template v-slot:item.stock_take_code="{ item }">
                        <span class="text-no-wrap">
                          <a
                            @click="
                              $router.push('/stock-take-orders/' + item.id)
                            "
                          >
                            {{ item.stock_take_code }}
                          </a>
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-data-table
          id="order_details_table"
          :headers="detailsHeaders"
          :items="stockInDetails"
          :search="filter"
          :item-key="savable && stock_in.type == 11 ? 'key' : ''"
          multi-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockOrderIN.DetailNoData')"
          :show-expand="
            savable &&
            stock_in.type == 11 &&
            settings &&
            settings.product_date_setting
              ? true
              : false
          "
          :expanded.sync="expanded"
          style="border-collapse: collapse"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockOrderIN.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <v-col v-if="isView && stock_in.supplier && stock_in.supplier.type == 2" cols="12" sm="2" md="2" class="align-end text-end">
                <span class="font-weight-bold me-2">
                  {{ $t("PurchasesDetail.express_price") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="danger--text">
                  {{ $t("Global.money") }}
                  {{ stock_in.express_price | formatMoney }}
                </span>
              </v-col>
              <span>
                <span class="font-weight-bold me-2">
                  {{ $t("StockOrderOUT.sum_price") }}
                  {{ $t("Global.colon") }}
                </span>
                <span class="danger--text">
                  {{ $t("Global.money") }}
                  {{
                    stock_in && stock_in.type == 2
                      ? stock_in.total_price
                      : total | formatMoney
                  }}
                 </span>
              </span>
              <v-btn
                v-if="isNew && stockSelected"
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="px-2 me-2 mb-1 mx-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("StockOrderIN.importMaterials") }}
              </v-btn>
              <v-btn
                v-if="stockInitialize"
                small
                color="print"
                dark
                @click.stop="InitImportDialog = true"
                class="px-2 me-2 mb-1 mx-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("StockOrderIN.importInitMaterials") }}
              </v-btn>
              <v-btn
                color="primary"
                small
                dark
                class="px-2 me-2 mb-1 mx-1"
                v-if="savable || stockInitialize"
                @click="stockMaterialsDialog = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stock_in.stock_order_details
                        ? [
                            1,
                            stock_in.stock_order_details.length,
                            stock_in.stock_order_details.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:header.price="{ header }">
            <span class="text-center text-no-wrap">
              {{ header.text }}

              <!-- <a
                v-if="
                  productionStockINFlg &&
                  mode == 'in' &&
                  stock_in.production_plan &&
                  stock_in.production_plan.production_type == 1
                "
                @click.stop="
                  stock_in_details.forEach((detail) => {
                    detail.price =
                      (detail.price == 0 || detail.price == null) &&
                      detail.produciton_in_price
                        ? detail.produciton_in_price
                        : detail.price;
                  })
                "
                >{{
                  $t("PurchasesDetail.purchaseFields.produciton_in_price")
                }}</a
              > -->
            </span>
          </template>
          <template v-slot:item.Description="{ item }">
            <a
              class="text-no-wrap"
              :class="item.error_flg ? 'red--text' : ''"
              @click.stop="dialogMaterialID = item.material_id"
            >
              {{ item.material_name }}
            </a>
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
              <span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.unit="{ item }">
            <v-select
              v-if="isNew || item.new"
              :items="item.standard_details"
              v-model="item.standard_detail_id"
              item-text="unit"
              item-value="id"
              noLabel
              single-line
              dense
              hide-details
              style="max-width: 60px"
              @change="resetPrice(item)"
            ></v-select>
            <span v-else> {{ item.unit }} </span>
          </template>
          <template v-slot:item.price="{ item }">
            <span v-if="item.negotiate_price_flg == 1">
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span v-else>
              <v-text-field
                v-if="
                  (((savable && stock_in.type != 11) || stockInitialize) &&
                    item.new) ||
                  (mode == 'edit' &&
                    (stock_in.type == 1 ||
                      stock_in.type == 12 ||
                      stock_in.type == 13)) ||
                  (savable &&
                    stock_in.type == 11 &&
                    settings &&
                    settings.purchase_subtotal != 1)
                "
                v-model="item.price"
                :placeholder="
                  $numberFormatter.formatMoneyFloor(item.price, 2) + ''
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatMoney(item.price, 2)
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span
                v-else-if="
                  isStockIN &&
                  stock_in.type == 2 &&
                  settings &&
                  settings.requisition_in_no_modify == 1
                "
              >
                {{ $t("Global.money") }}{{ item.price | formatMoney }}
              </span>
              <span
                v-else-if="
                  isStockIN &&
                  stock_in &&
                  stock_in.type == 11 &&
                  settings &&
                  settings.purchase_subtotal == 1
                "
              >
                {{ $t("Global.money") }}{{ item.price | formatMoney }}
              </span>
              <ValidationProvider
                v-else-if="
                  (isStockIN && stock_in.type != 11) ||
                  (isStockIN && stock_in.type == 11 && !stock_in.purchase_code)
                "
                v-slot="{ errors }"
                rules="trequired"
              >
                <v-text-field
                  v-model="item.price"
                  :placeholder="
                    $numberFormatter.formatMoneyFloor(item.price, 2) + ''
                  "
                  single-line
                  dense
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    item.price = $numberFormatter.formatMoney(
                      item.price,
                      2
                    )
                  "
                  @change="resetTotal()"
                  style="max-width: 80px; margin-left: auto"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <span v-else>
                {{ $t("Global.money") }}{{ item.price | formatMoney }}
              </span>
            </span>
          </template>
          <template v-slot:item.current_count="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.current_count }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_current_count | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.order_num="{ item }">
            <NumberInput
              v-if="savable || stockInitialize"
              v-model="item.order_num"
              dense
            />
            <span v-else> {{ item.order_num | formatTwoDot }} </span>
          </template>
          <template v-slot:item.confirm_num="{ item }">
            <NumberInput
              v-if="
                productionStockINFlg &&
                isStockIN &&
                !(stock_in.type == 11 && stock_in.bill_purchase.order_code)
              "
              v-model="item.confirm_num"
              dense
              @input="resetTotal"
            />
            <span v-else>
              {{ item.confirm_num | formatTwoDot }}
            </span>
          </template>
          <!-- 小计 -->
          <template v-slot:item.total="{ item }">
            <span v-if="item.negotiate_price_flg == 1">
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span v-else>
              <v-text-field
                v-if="
                  (savable || isStockIN) &&
                  stock_in.type == 11 &&
                  !stock_in.purchase_code &&
                  settings &&
                  settings.purchase_subtotal == 1
                "
                v-model="item.total"
                :placeholder="
                  $numberFormatter.formatMoneyFloor(item.total, 2) + ''
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.total = $numberFormatter.formatMoneyFloor(item.total)
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                <span v-if="stock_in.type == 4 || stock_in.type == 11">
                  {{ $t("Global.money") }}{{ item.total | formatMoneyFloor }}
                </span>
                <span v-else-if="stock_in.status > 1">
                  {{ $t("Global.money") }}{{ item.confirm_price | formatMoneyFloor }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.total | formatMoneyFloor }}
                </span>
              </span>
            </span>
          </template>
          <template v-slot:item.production_date="{ item }">
            <SearcherDatetime
              v-if="savable || isStockIN || stockInitialize"
              class="my-n2"
              v-model="item.production_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
              disabled-after-now
              :required="
                (item.material && Number(item.material.bestbefore) > 0) ||
                settings.material_force_bestbefore == 1
              "
            >
            </SearcherDatetime>
            <span v-else>{{ item.production_date | formatDate }}</span>
          </template>
          <template v-slot:item.expired_date="{ item }">
            <SearcherDatetime
              v-if="savable || isStockIN || stockInitialize"
              class="my-n2"
              v-model="item.expired_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
              disabled-before-today
              :required="
                (item.material && Number(item.material.bestbefore) > 0) ||
                settings.material_force_bestbefore == 1
              "
            >
            </SearcherDatetime>
            <span v-else>{{ item.expired_date | formatDate }}</span>
          </template>
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-if="savable || stockInitialize || item.edit_memo"
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 120px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = item;
                    memo_dialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
                <v-icon
                  v-if="!savable"
                  x-small
                  @click.stop="saveAttachment(item)"
                  class="pt-2 pb-1 primary--text ml-2"
                >
                  fa-check
                </v-icon>
              </template>
            </v-text-field>
            <span v-else>
              <span
                v-if="item.memo && item.memo.length > 6"
                :title="item.memo"
                style="cursor: pointer"
              >
                {{ item.memo.slice(0, 6) + "......" }}
              </span>
              <span v-else>
                {{ item.memo }}
              </span>
              <v-icon
                v-if="!item.edit_memo"
                x-small
                color="primary"
                class=""
                style="display: inline-block"
                @click.stop="setEditMemoFlg(item)"
              >fa-pencil-alt
              </v-icon>
            </span>
          </template>
          <template v-slot:item.qualify_report_img="{ item }">
            <!-- 质检报告 -->
            <v-btn
              v-if="
                stock_in &&
                stock_in.type == 11 &&
                item &&
                item.qualify_report_img_url &&
                item.qualify_report_img_url.length
              "
              color="orange"
              style="color: white"
              class="my-1"
              small
              @click.stop="
                currentItem = item;
                qualifyReportDialog = true;
              "
            >
              {{ $t("PurchasesDetail.purchaseFields.qualify_report") }}
            </v-btn>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.new"
              small
              text
              class="danger--text pa-0"
              @click.stop="
                stock_in_details.splice(
                  stock_in_details.findIndex((detail) =>
                    item.id ? item.id == detail.id : item.new == detail.new
                  ),
                  1
                )
              "
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>

          <template
            v-if="!isNew && !stockInitialize && stockInDetails.length"
            v-slot:body.prepend
          >
            <tr no-gutters class="d-none d-sm-table-row">
              <td class="secondary--text" :colspan="isView ? '4' : '5'">
                {{ $t("StockOrderIN.DetailFields.count_num") }}
              </td>
              <td class="text-center">
                {{ stock_in.order_num_count | formatTwoDot }}
              </td>
              <td
                v-if="isView || (!isNew && stock_in.status != 1)"
                class="text-center"
              >
                {{ stock_in.confirm_num_count | formatTwoDot }}
              </td>
              <td></td>
              <td v-if="isView" class="text-center">
                {{ $t("Global.money") }}{{ stock_in.count_price | formatMoney }}
              </td>
              <td colspan="7"></td>
            </tr>
            <tr no-gutters class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t(
                      stockInitialize
                        ? "StockOrderIN.DetailFields.stock_in_num"
                        : "StockOrderIN.DetailFields.order_num"
                    )
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ stock_in.order_num_count | formatTwoDot }}
                </div>
              </td>
              <td
                v-if="isView || (!isNew && stock_in.status != 1)"
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__header">
                  {{ $t("StockOrderIN.DetailFields.stock_in_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ stock_in.confirm_num_count | formatTwoDot }}
                </div>
              </td>
              <td v-if="isView" class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("StockOrderIN.DetailFields.subtotal_price") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money")
                  }}{{ stock_in.count_price | formatMoney }}
                </div>
              </td>
            </tr>
          </template>
          <!-- expend扩展行 -->
          <template v-slot:expanded-item="{ item }">
            <td colspan="3" class="pa-0">
              <div style="height: 50px"></div>
              <v-divider />
              <div style="height: 50px"></div>
            </td>

            <!-- 单价 -->
            <td class="pa-0">
              <div style="height: 50px; line-height: 50px" class="text-center">
                <span
                  v-if="
                    savable &&
                    stock_in.type == 11 &&
                    settings &&
                    settings.purchase_subtotal == 1
                  "
                >
                  {{ $t("Global.money") }}{{ item.price_2 | formatMoney }}
                </span>
              </div>
              <v-divider />
              <div style="height: 50px; line-height: 50px" class="text-center">
                <span
                  v-if="
                    savable &&
                    stock_in.type == 11 &&
                    settings &&
                    settings.purchase_subtotal == 1
                  "
                >
                  {{ $t("Global.money") }}{{ item.price_3 | formatMoney }}
                </span>
              </div>
            </td>
            <td v-if="isEdit" class="pa-0">
              <div style="height: 50px"></div>
              <v-divider />
              <div style="height: 50px"></div>
            </td>
            <!-- 申请量 -->
            <td class="pa-0">
              <div class="pa-3" style="height: 50px">
                <NumberInput
                  v-if="savable || stockInitialize"
                  v-model="item.order_num_2"
                  dense
                />
              </div>
              <v-divider />
              <div class="pa-3" style="height: 50px">
                <NumberInput
                  v-if="savable || stockInitialize"
                  v-model="item.order_num_3"
                  dense
                />
              </div>
            </td>
            <td v-if="isEdit" class="pa-0">
              <div style="height: 50px"></div>
              <v-divider />
              <div style="height: 50px"></div>
            </td>
            <!-- 小计 -->
            <td class="pa-0">
              <div
                class="pa-3"
                style="height: 50px"
                v-if="
                  savable &&
                  stock_in.type == 11 &&
                  settings &&
                  settings.purchase_subtotal == 1
                "
              >
                <v-text-field
                  v-model="item.total_2"
                  :placeholder="
                    $numberFormatter.formatMoneyFloor(item.total_2, 2) + ''
                  "
                  single-line
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    item.total_2 = $numberFormatter.formatMoneyFloor(
                      item.total_2
                    )
                  "
                  style="max-width: 80px; margin-left: auto"
                />
              </div>
              <div
                style="height: 50px; line-height: 50px"
                class="text-center"
                v-else
              >
                <span>
                  {{ $t("Global.money") }}{{ item.total_2 | formatMoney }}
                </span>
              </div>
              <v-divider />
              <div
                class="pa-3"
                style="height: 50px"
                v-if="
                  savable &&
                  stock_in.type == 11 &&
                  settings &&
                  settings.purchase_subtotal == 1
                "
              >
                <v-text-field
                  v-model="item.total_3"
                  :placeholder="
                    $numberFormatter.formatMoneyFloor(item.total_3, 2) + ''
                  "
                  single-line
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    item.total_3 = $numberFormatter.formatMoneyFloor(
                      item.total_3
                    )
                  "
                  style="max-width: 80px; margin-left: auto"
                />
              </div>
              <div
                style="height: 50px; line-height: 50px"
                class="text-center"
                v-else
              >
                <span>
                  {{ $t("Global.money") }}{{ item.total_3 | formatMoney }}
                </span>
              </div>
            </td>
            <!-- 生产日期 -->
            <td class="pa-0">
              <div class="pa-3" style="height: 50px">
                <SearcherDatetime
                  v-if="savable || stockInitialize"
                  class="my-n2"
                  v-model="item.production_date_2"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabled-after-now
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    settings.material_force_bestbefore == 1
                  "
                >
                </SearcherDatetime>
              </div>
              <v-divider />
              <div class="pa-3" style="height: 50px">
                <SearcherDatetime
                  v-if="savable || stockInitialize"
                  class="my-n2"
                  v-model="item.production_date_3"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabled-after-now
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    settings.material_force_bestbefore == 1
                  "
                >
                </SearcherDatetime>
              </div>
            </td>
            <!-- 过期日期 -->
            <td class="pa-0">
              <div class="pa-3" style="height: 50px">
                <SearcherDatetime
                  v-if="savable || stockInitialize"
                  class="my-n2"
                  v-model="item.expired_date_2"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabled-before-today
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    settings.material_force_bestbefore == 1
                  "
                >
                </SearcherDatetime>
              </div>
              <v-divider />
              <div class="pa-3" style="height: 50px">
                <SearcherDatetime
                  v-if="savable || stockInitialize"
                  class="my-n2"
                  v-model="item.expired_date_3"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabled-before-today
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    settings.material_force_bestbefore == 1
                  "
                >
                </SearcherDatetime>
              </div>
            </td>
            <!-- 备注 -->
            <td class="pa-0">
              <div class="pa-3" style="height: 50px">
                <v-text-field
                  v-if="savable || stockInitialize"
                  v-model="item.memo_2"
                  single-line
                  dense
                  hide-details
                  style="max-width: 120px"
                >
                  <template v-slot:append>
                    <v-icon
                      x-small
                      @click.stop="
                        detail_memo_item = item;
                        memo_dialog = true;
                      "
                      class="pt-2 pb-1 primary--text"
                    >
                      fa-edit
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <v-divider />
              <div class="pa-3" style="height: 50px">
                <v-text-field
                  v-if="savable || stockInitialize"
                  v-model="item.memo_3"
                  single-line
                  dense
                  hide-details
                  style="max-width: 120px"
                >
                  <template v-slot:append>
                    <v-icon
                      x-small
                      @click.stop="
                        detail_memo_item = item;
                        memo_dialog = true;
                      "
                      class="pt-2 pb-1 primary--text"
                    >
                      fa-edit
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </td>
            <td colspan="2" class="pa-0">
              <div style="height: 50px"></div>
              <v-divider />
              <div style="height: 50px"></div>
            </td>
          </template>

          <template v-slot:footer>
            <v-row
              v-if="savable || stockInitialize"
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <span class="secondary--text">
                {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherStockMaterial
                v-model="selectMaterial"
                :stock-id="
                  stock_in.stock_id && stock_in.type ? stock_in.stock_id : null
                "
                :typeFlg="'stockOrdersIn'"
                :disabledItems="
                  stock_in.type == 12 || stock_in.type == 13
                    ? []
                    : stock_in_details
                    ? stock_in_details.map((detail) => {
                        return { material_id: detail.material_id };
                      })
                    : []
                "
                no-label
                :status="[1]"
              />
            </v-row>
          </template>
        </v-data-table>
      </ValidationObserver>
    </v-sheet>

    <MaterialDialog v-model="dialogMaterialID" />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('StockOrderIN.ObjectName')"
      @import="
        excelFile = $event;
        importExcel();
      "
      :stock_id="stockSelected ? stockSelected.id : null"
    />
    <InitImportExcelAlert
      v-model="InitImportDialog"
      :objName="$t('StockOrderIN.ObjectName')"
      @import="
        excelFile = $event;
        initImportExcel();
      "
      :stock_id="stock_id ? stock_id : null"
    />
    <DialogImages
      v-model="qualifyReportDialog"
      :img_url="
        currentItem && currentItem.qualify_report_img_url
          ? currentItem.qualify_report_img_url
          : []
      "
    />
    <StockMaterialsSelectsDialog
      v-model="stockMaterialsDialog"
      :stock-id="stock_in.stock_id && stock_in.type ? stock_in.stock_id : null"
      :disabledItems="
        stock_in.type == 12 || stock_in.type == 13 ? [] : stock_in_details
      "
      :status="[1]"
      :typeFlg="'stockOrdersIn'"
      @confirm="selectMaterials = $event"
    />
    <DialogDateError v-model="dateErrorDialog" :errorData="dateErrorData" />

    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
              class="red--text d-inline-block text-truncate"
              style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
              v-model="detail_memo_item.memo"
              outlined
              :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockIns from "@/api/stock_ins";
import Stocks from "@/api/stocks";
import StockOrderINActions from "./plugins/Actions";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import SearcherShop from "@/components/plugins/SearcherShop";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import InitImportExcelAlert from "./plugins/InitImportExcelAlert";
import snackbar from "@/plugins/snackbar";
import StockMaterials from "@/api/stock_materials";
// import DialogPostImages from "@/components/plugins/DialogPostImages";
import DialogImages from "@/components/plugins/DialogImages";
import StockMaterialsSelectsDialog from "@/components/plugins/StockMaterialsSelectsDialog";
import Files from "@/api/files";
import DialogDateError from "@/components/plugins/DialogDateError";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderINActions,
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
    SearcherStock,
    SearcherStockMaterial,
    NumberInput,
    MaterialDialog,
    SearcherSupplier,
    SearcherShop,
    ImportExcelAlert,
    InitImportExcelAlert,
    // DialogPostImages,
    DialogImages,
    StockMaterialsSelectsDialog,
    DialogDateError,
  },
  computed: {
    stock_id() {
      return this.stockSelected
        ? this.stockSelected.id
        : this.$route.query.stock_id
        ? Number(this.$route.query.stock_id)
        : null;
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "new" || this.mode == "edit";
    },
    isNew() {
      return this.mode == "new";
    },
    isEdit() {
      return this.mode == "edit";
    },
    isStockIN() {
      return this.mode == "in";
    },
    stockInitialize() {
      return this.mode == "stockInitialize";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.productionStockINFlg
            ? i18n.t("Nav.productionManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: this.productionStockINFlg ? "/production-plans" : "/stocks",
        },
        {
          text: this.productionStockINFlg
            ? i18n.t("Nav.productionStockIN")
            : this.stockInitialize
            ? i18n.t("Nav.stockInitializeStockIn")
            : i18n.t("Nav.stockOrdersIn"),
          disabled: this.stockInitialize ? true : false,
          href: this.productionStockINFlg
            ? "/production-stock-in"
            : "/stock-orders-in",
        },
      ];
      if (!this.stockInitialize) {
        items.push({
          text: this.isNew
            ? i18n.t("Nav.stockInNew")
            : this.productionStockINFlg
            ? i18n.t("Nav.productionStockINDetail")
            : i18n.t("Nav.stockInDetail"),
          disabled: true,
        });
      }
      if (!this.isNew && !this.stockInitialize) {
        items.push({
          text:
            this.stock_in && this.stock_in.stock_order_code
              ? this.stock_in.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderIN.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderIN.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockOrderIN.DetailFields.material"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("StockOrderIN.DetailFields.unit"),
          align: "center",
          value: "unit",
        }
      ];

      if (this.isNew) {
        headers.push({
          text: i18n.t("StockOrderIN.DetailFields.order_num"),
          align: "center",
          value: "order_num",
        });
      } else if (this.stockInitialize) {
        headers.push({
          text: i18n.t("StockOrderIN.DetailFields.stock_in_num"),
          align: "center",
          value: "order_num",
        });
      } else if (this.isView) {
        headers.push(
          {
            text: i18n.t("StockOrderIN.DetailFields.order_num"),
            align: "center",
            value: "order_num",
          },
          {
            text: i18n.t("StockOrderIN.DetailFields.stock_in_num"),
            align: "center",
            value: "confirm_num",
          }
        );
      } else {
        headers.push(
          {
            text: i18n.t("StockOrderIN.DetailFields.current_stock_quantity"),
            align: "center",
            value: "current_count",
          },
          {
            text: i18n.t("StockOrderIN.DetailFields.stock_in_confirm_num"),
            align: "center",
            value: "order_num",
          }
        );
        if (
          !(
            this.mode == "edit" &&
            (this.stock_in.type == 12 || this.stock_in.type == 13)
          )
        ) {
          headers.push({
            text: i18n.t("StockOrderIN.DetailFields.stock_in_practical_num"),
            align: "center",
            value: "confirm_num",
          });
        }
      }

      headers.push(
        {
          text: i18n.t("StockOrderIN.DetailFields.price"),
          align: "center",
          value: "price",
        },
        {
          text: i18n.t("StockOrderIN.DetailFields.subtotal_price"),
          align: "center",
          value: "total",
        }
      );

      if (this.settings && this.settings.product_date_setting) {
        headers.push(
          {
            text: i18n.t("StockOrderIN.DetailFields.production_date"),
            align: "center",
            value: "production_date",
            width: 136,
          },
          {
            text: i18n.t("StockOrderIN.DetailFields.expired_date"),
            align: "center",
            value: "expired_date",
            width: 136,
          }
        );
      }
      if (!this.productionStockINFlg) {
        headers.push({
          text: i18n.t("StockOrderIN.DetailFields.memo"),
          align: "start",
          value: "memo",
          width: 180
        });
      }

      if (
        this.stock_in.type == 11 &&
        !this.savable &&
        this.settings &&
        this.settings.qualify_report_enable == 1
      ) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.qualify_report"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "qualify_report_img",
        });
      }

      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        });
        if (
          this.stock_in.type == 11 &&
          this.settings &&
          this.settings.product_date_setting
        ) {
          headers.push({
            text: "",
            align: "center",
            sortable: false,
            value: "data-table-expand",
          });
        }
      }

      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("StockOrderIN.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockOrderIN.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("StockOrderIN.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    stockInDetails() {
      return this.stock_in_details.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [
            detail.material_code,
            detail.material_name,
            detail.new ? detail.material.standard_name : detail.standard_name,
          ]
        );
        if (this.editMemoData && detail.id == this.editMemoData.id) {
          detail.edit_memo = 1;
        }else {
          detail.edit_memo = 0;
        }
        return detail;
      });
    },
    relationsHeaders() {
      var headers = [
        {
          text: i18n.t("Order.RelationFields.identify_name"),
          align: "center",
          sortable: false,
          value: "identify_name",
        },
        {
          text: i18n.t("Order.RelationFields.identify_code"),
          align: "center",
          sortable: false,
          value: "identify_code",
        },
        {
          text: i18n.t("Order.RelationFields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Order.RelationFields.creater"),
          align: "start",
          sortable: false,
          value: "creater_name",
        },
        {
          text: i18n.t("Order.RelationFields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
      ];
      if (this.stock_in.type == 4) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    relationsStockTakeHeaders: () => [
      {
        text: i18n.t("Order.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "relations_name",
      },
      {
        text: i18n.t("Order.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "stock_take_code",
      },
      {
        text: i18n.t("Order.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("Order.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  mounted() {
    if (this.$route.path.startsWith("/stock-orders-in/new")) {
      this.mode = "new";
    } else if (this.$route.path.startsWith("/stocks/initialize")) {
      this.mode = "stockInitialize";
    } else {
      this.mode = this.$route.params.mode;
      if (this.$route.path.startsWith("/production-stock-in")) {
        this.productionStockINFlg = true;
        if (this.mode) {
          this.$router.replace("/production-stock-in/" + this.$route.params.id);
        }
      } else if (this.$route.path.startsWith("/stock-orders-in")) {
        if (this.mode) {
          this.$router.replace("/stock-orders-in/" + this.$route.params.id);
        }
      }
    }
  },

  data: () => ({
    productionStockINFlg: false,
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    stock_in: {},
    stock_in_details: [],
    stock_in_activities: [],
    bill_purchase: [],
    stockSelected: null,
    supplierSelected: null,
    shopSelected: null,
    datetimeRage: [new Date()],
    standard_detail: null,
    addMaterial: null,
    selectMaterial: null,
    selectMaterials: [],
    dialogMaterialID: null,
    ImportDialog: false,
    InitImportDialog: false,
    excelFile: null,
    // addMaterials: [],
    relations: [],
    expanded: [],
    qualifyReportDialog: false,
    currentItem: null,
    stockMaterialsDialog: false,
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    total: 0,
    dateErrorDialog: false,
    dateErrorData: [],
    edit_attachment: false,
    editMemoData: null,
    memo_dialog: false,
    memo_dialog_memo: "",
    detail_memo_item: { memo: "" },
  }),

  methods: {
    getStockInsFromAPI() {
      StockIns.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_in = response.data.stock_in;
            this.album = response.data.stock_in.img;
            this.stock_in_activities = response.data.order_activities;
            this.bill_purchase = response.data.stock_in.bill_purchase;
            this.stock_in.order_num_count = 0;
            this.stock_in.confirm_num_count = 0;
            this.stock_in.count_price = 0;
            this.stock_in.attachment = this.stock_in.attachment
              ? this.stock_in.attachment
              : this.stock_in.order_code
              ? this.stock_in.order_memo
              : this.stock_in.attachment;
            this.stock_in.stock_order_details.forEach((stock_order_detail) => {
              //申请出库量总计
              if (this.stock_in.status == 1 && this.stock_in.type != 4) {
                stock_order_detail.total = stock_order_detail.order_price;
              } else if (this.stock_in.type != 4) {
                stock_order_detail.total = stock_order_detail.confirm_price;
              }
              this.stock_in.order_num_count += Number(
                stock_order_detail.order_num
              );
              this.stock_in.confirm_num_count += Number(
                stock_order_detail.confirm_num
              );
              this.stock_in.count_price += Number(stock_order_detail.total);
              if (
                this.stock_in.type == 1 &&
                this.stock_in.order_id &&
                (this.isStockIN || this.isView)
              ) {
                if (
                  !this.stock_in.return_basket_id ||
                  this.stock_in.return_basket_id == 0
                ) {
                  stock_order_detail.price = stock_order_detail.stock_in_price;
                }
              }
              if (this.stock_in.type == 4 && (this.isStockIN || this.isView)) {
                stock_order_detail.price = stock_order_detail.production_price;
              }
            });
            if (this.stock_in.type == 1) {
              this.relations = [];
              if (this.stock_in.return_order) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "ReturnOrders",
                      identify_name: i18n.t("ReturnOrder.ObjectName"),
                      identify_code:
                        response.data.stock_in.return_order.order_code,
                      all_loss_flg: response.data.stock_in.all_loss_flg,
                    },
                    response.data.stock_in.return_order
                  )
                );
                if (this.stock_in.order) {
                  this.relations.push(
                    Object.assign(
                      {
                        controller: "Orders",
                        identify_name: i18n.t("Order.ObjectName"),
                        identify_code: response.data.stock_in.order.order_code,
                        all_loss_flg: response.data.stock_in.all_loss_flg,
                      },
                      response.data.stock_in.order
                    )
                  );
                }
              }
              if (this.stock_in.bill) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Receipt",
                      identify_name: i18n.t("Bill.ObjectName"),
                      identify_code: response.data.stock_in.bill.bill_code,
                      all_loss_flg: response.data.stock_in.all_loss_flg,
                    },
                    response.data.stock_in.bill
                  )
                );
                if (
                  this.stock_in.finance_bill &&
                  this.settings &&
                  this.settings.finance_bill_enable == 1
                ) {
                  this.relations.push(
                    Object.assign(
                      {
                        controller: "FinanceBills",
                        identify_name: i18n.t(
                          "ReceiptBillAnalyze.billTypes.billTypePurchase"
                        ),
                        identify_code:
                          response.data.stock_in.finance_bill.finance_bill_code,
                      },
                      response.data.stock_in.finance_bill
                    )
                  );
                }
              }
            }
            if (this.stock_in.type == 11 || this.stock_in.examine) {
              this.relations = [];
              if (this.stock_in.bill) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Receipt",
                      identify_name: i18n.t("Bill.ObjectName"),
                      identify_code: response.data.stock_in.bill.bill_code,
                      all_loss_flg: response.data.stock_in.all_loss_flg,
                    },
                    response.data.stock_in.bill
                  )
                );
                if (
                  this.stock_in.finance_bill &&
                  this.settings &&
                  this.settings.finance_bill_enable == 1
                ) {
                  this.relations.push(
                    Object.assign(
                      {
                        controller: "FinanceBills",
                        identify_name: i18n.t(
                          "ReceiptBillAnalyze.billTypes.finance_bill"
                        ),
                        identify_code:
                          response.data.stock_in.finance_bill.finance_bill_code,
                      },
                      response.data.stock_in.finance_bill
                    )
                  );
                }
              }
              if (this.stock_in.bill_purchase) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Purchases",
                      identify_name: i18n.t("PurchasesList.ObjectName"),
                      identify_code:
                        response.data.stock_in.bill_purchase.purchase_code,
                    },
                    response.data.stock_in.bill_purchase
                  )
                );
              }
              if (this.stock_in.examine) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Examines",
                      identify_name: i18n.t("Examine.ObjectName"),
                      identify_code:
                        response.data.stock_in.examine.examine_code,
                    },
                    response.data.stock_in.examine
                  )
                );
              }
            }
            if (this.stock_in.type == 3) {
              this.relations = [];
              this.relations.push(this.stock_in.stock_take);
            }
            if (this.stock_in.type == 4) {
              this.relations = [];
              this.relations.push(
                Object.assign(
                  {
                    controller: "ProductionPlans",
                    identify: "production-plans",
                    identify_name: i18n.t("ProductionPlans.ObjectName"),
                    creater_name: this.stock_in.creater_name,
                    identify_code:
                      response.data.stock_in.production_plan.production_code,
                  },
                  response.data.stock_in.production_plan
                )
              );
            }

            if (this.stock_in.type == 11 && this.savable) {
              // 加工编辑折叠数据
              let allDetails = [];
              this.stock_in.stock_order_details.forEach(
                (stock_order_detail) => {
                  if (!allDetails[stock_order_detail.material_id]) {
                    allDetails[stock_order_detail.material_id] = [];
                  }
                  allDetails[stock_order_detail.material_id].push(
                    stock_order_detail
                  );
                }
              );

              this.stock_in.stock_order_details = [];
              allDetails.forEach((detail) => {
                let stockOrderDetails = [];
                stockOrderDetails = detail[0];
                stockOrderDetails.key =
                  this.stock_in.stock_order_details.length + 1;
                if (detail.length > 1) {
                  stockOrderDetails.id_2 = detail[1]["id"];
                  stockOrderDetails.order_num_2 = detail[1]["order_num"];
                  stockOrderDetails.total_2 = detail[1]["total"];
                  stockOrderDetails.production_date_2 =
                    detail[1]["production_date"];
                  stockOrderDetails.expired_date_2 = detail[1]["expired_date"];
                  stockOrderDetails.memo_2 = detail[1]["memo"];
                }
                if (detail.length > 2) {
                  stockOrderDetails.id_3 = detail[2]["id"];
                  stockOrderDetails.order_num_3 = detail[2]["order_num"];
                  stockOrderDetails.total_3 = detail[2]["total"];
                  stockOrderDetails.production_date_3 =
                    detail[2]["production_date"];
                  stockOrderDetails.expired_date_3 = detail[2]["expired_date"];
                  stockOrderDetails.memo_3 = detail[2]["memo"];
                }
                this.stock_in.stock_order_details.push(stockOrderDetails);
                if (detail.length > 1) {
                  this.expanded.push(stockOrderDetails);
                }
              });
            }
          }
        }.bind(this)
      );
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var imgs = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images",
              true
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => imgs.push(img.img_name));
          }
        }
      }
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let data = [];
            this.stock_in_details.forEach((detail) => {
              if (detail.default_standard_detail_id) {
                delete detail.default_standard_detail_id;
              }
              if (detail.order_num > 0) {
                if (this.settings && this.settings.product_date_setting) {
                  data.push({
                    id: detail.id,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    order_num: detail.order_num,
                    total: detail.total,
                    production_date: detail.production_date,
                    expired_date: detail.expired_date,
                    memo: detail.memo,
                    qualify_report_img:
                      this.stock_in.type == 11
                        ? detail.qualify_report_img &&
                          detail.qualify_report_img.length
                          ? detail.qualify_report_img.map((img) => {
                              if (img.img_name) {
                                return img.img_name;
                              } else {
                                return img;
                              }
                            })
                          : []
                        : [], //质检报告
                  });
                } else {
                  data.push({
                    id: detail.id,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    order_num: detail.order_num,
                    total: detail.total,
                    memo: detail.memo,
                    qualify_report_img:
                      this.stock_in.type == 11
                        ? detail.qualify_report_img &&
                          detail.qualify_report_img.length
                          ? detail.qualify_report_img.map((img) => {
                              if (img.img_name) {
                                return img.img_name;
                              } else {
                                return img;
                              }
                            })
                          : []
                        : [],
                  });
                }
              }

              if (detail.order_num_2 > 0) {
                if (this.settings && this.settings.product_date_setting) {
                  data.push({
                    id: detail.id_2,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    order_num: detail.order_num_2,
                    total: detail.total,
                    production_date: detail.production_date_2,
                    expired_date: detail.expired_date_2,
                    memo: detail.memo_2,
                  });
                } else {
                  data.push({
                    id: detail.id_2,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    order_num: detail.order_num_2,
                    total: detail.total,
                    memo: detail.memo_2,
                  });
                }
              }

              if (detail.order_num_3 > 0) {
                if (this.settings && this.settings.product_date_setting) {
                  data.push({
                    id: detail.id_3,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    order_num: detail.order_num_3,
                    total: detail.total,
                    production_date: detail.production_date_3,
                    expired_date: detail.expired_date_3,
                    memo: detail.memo_3,
                  });
                } else {
                  data.push({
                    id: detail.id_3,
                    material_code: detail.material_code,
                    material_id: detail.material_id,
                    standard_detail_id: detail.standard_detail_id,
                    price: detail.price,
                    total: detail.total,
                    order_num: detail.order_num_3,
                    memo: detail.memo_3,
                  });
                }
              }
            });
            if (this.mode == "edit") {
              // this.stock_in.stock_order_details = data;
              this.submitUploadImg();
              StockIns.edit(
                this.stock_in.id,
                Object.assign({}, this.stock_in, { stock_order_details: data })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      this.$router.push(
                        this.productionStockINFlg
                          ? "/production-stock-in"
                          : "/stock-orders-in"
                      );
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
            if (this.mode == "new" || this.stockInitialize) {
              if (
                this.stockInitialize &&
                this.stock_in.stock &&
                this.stock_in.stock.status != -1
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("StockOrderIN.Messages.initialize_stock_in_err")
                );
                return;
              }
              if (this.mode == "new") {
                this.stock_in = Object.assign({}, this.stock_in, { img: imgs });
              }
              // this.stock_in.stock_order_details = data;
              StockIns.add(
                Object.assign({}, this.stock_in, { stock_order_details: data })
              )
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$refs.observer.reset();
                      this.$router.push(
                        this.productionStockINFlg
                          ? "/production-stock-in"
                          : "/stock-orders-in"
                      );
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    doStockIN(type) {
      this.$store.dispatch("fullscreenLoading");
      this.submitUploadImg();
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            this.stock_in_details.forEach((detail) => {
              detail.qualify_report_img =
                detail.qualify_report_img && detail.qualify_report_img
                  ? detail.qualify_report_img.map((img) => {
                      if (img.img_name) {
                        return img.img_name;
                      } else {
                        return img;
                      }
                    })
                  : [];
            });
            StockIns.stockIN(type, this.stock_in)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$refs.observer.reset();
                    this.$router.push(
                      this.productionStockINFlg
                        ? "/production-stock-in"
                        : "/stock-orders-in"
                    );
                  } else if (
                    response.data.error &&
                    response.data.error.code &&
                    response.data.error.code == "ERR427"
                  ) {
                    this.dateErrorData = response.data.data;
                    this.dateErrorDialog = true;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockIns.imports(this.excelFile, this.stock_in.stock_id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.info(
                i18n.t("Import.success", [i18n.t("StockOrderIN.title")])
              );

              this.ImportDialog = false;
              this.addMaterials(response.data.materials, true);
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    initImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockIns.initImports(this.excelFile, this.stock_in.stock_id)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.info(
                i18n.t("Import.success", [i18n.t("StockOrderIN.title")])
              );

              this.InitImportDialog = false;
              this.addMaterials(response.data.materials, true);
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var stock_in_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images",
            true
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => stock_in_img.push(img.img_name));
          StockIns.update({
            stock_order_code: this.stock_in.stock_order_code,
            img: stock_in_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    resetTotal() {
      if (
        this.stock_in.type == 4 ||
        (this.stock_in.type == 11 &&
          this.settings &&
          this.settings.purchase_subtotal != 1)
      ) {
        let total = 0;
        this.stock_in_details.forEach((detail) => {
          let confirm_num = detail.confirm_num ? detail.confirm_num : 0;
          if (confirm_num) {
            detail.total = this.$numberFormatter.formatMoneyFloor(
              parseFloat(Number(detail.price?detail.price:0) * Number(confirm_num)).toFixed(4)
            );
          }
          total += Number(detail.total);
        });
        this.total = total;
      }
    },
    addMaterials(materials, isFromImport) {
      materials.forEach((addMaterial) => {
        if (addMaterial && addMaterial.id) {
          //获取库存单位
          var standard_detail = addMaterial.standard_detail
            ? addMaterial.standard_detail
            : "";

          //判断库存单位是否是默认单位
          var current_quantity_with_unit = "";
          var current_count_with_unit = "";
          if (!standard_detail.default_flg) {
            var standard_detail_default = addMaterial.standard_details.find(
              (standard_detail) => standard_detail.default_flg == 1
            );
            current_count_with_unit = i18n.t("Stock.stockQuantity", [
              addMaterial.current_count,
              standard_detail_default.unit,
            ]);
            //库存单位与默认单位转换
            if (addMaterial.current_count) {
              //库存量不为零
              //大单位取整
              var current_quantity_int = parseInt(
                addMaterial.current_count / standard_detail.rate
              );
              //小单位取余
              if (addMaterial.current_count % standard_detail.rate) {
                var current_quantity_decimal =
                  addMaterial.current_count % standard_detail.rate;
                current_quantity_with_unit = i18n.t(
                  "Stock.stockQuantityWithMultipleUnits",
                  [
                    current_quantity_int,
                    standard_detail.unit,
                    current_quantity_decimal,
                    standard_detail_default.unit,
                  ]
                );
              } else {
                current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
                  current_quantity_int,
                  standard_detail.unit,
                ]);
              }
            } else {
              //库存量为零
              current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
                addMaterial.current_count,
                standard_detail.unit,
              ]);
            }
          } else {
            current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
              addMaterial.current_count,
              standard_detail.unit,
            ]);
          }
          if (
            (this.stock_in.type == 1 ||
              this.stock_in.type == 12 ||
              this.stock_in.type == 13) &&
            !isFromImport
          ) {
            //导入商品单价取接口in_price
            addMaterial.in_price = addMaterial.stock_in_price;
          }
          this.stock_in_details.push({
            new: this.stock_in_details.length + 1,
            key: this.stock_in_details.length + 1,
            stock_out_id: this.stock_in.id,
            category_name: addMaterial.category_name,
            material_id: addMaterial.material_id,
            material_code: addMaterial.material_code,
            material_name: addMaterial.material_name,
            unit: addMaterial.unit,
            standard_detail_unit: standard_detail.unit,
            current_count_with_unit: current_count_with_unit,
            current_quantity_with_unit: current_quantity_with_unit,
            price: addMaterial.in_price,
            order_num: addMaterial.order_num,
            total: addMaterial.total,
            production_date: addMaterial.production_date,
            expired_date: addMaterial.expired_date,
            memo: null,
            standard_details: addMaterial.standard_details,
            material: addMaterial,
            standard_name: addMaterial.standard
              ? addMaterial.standard.name
              : "",
            standard_detail_id: addMaterial.standard_detail_id,
            default_standard_detail_id: addMaterial.standard_detail_id, //判断单位是否切换，不提交
          });
        }
      });
    },
    resetPrice(data) {
      this.stock_in_details.forEach((detail) => {
        if (detail.material_id == data.material_id) {
          // 找到对应的商品后根据单位重新修改单价
          let standard_detail = data.standard_detail_id
            ? data.standard_details.find((d) => d.id == data.standard_detail_id)
            : null;
          if (standard_detail) {
            let price =
              this.stock_in.type == 11
                ? standard_detail.in_price
                : standard_detail.supply_price
                ? standard_detail.supply_price
                : 0;
            if (
              this.stock_in.type == 1 ||
              this.stock_in.type == 12 ||
              this.stock_in.type == 13
            ) {
              price = standard_detail.stock_in_price;
            }
            detail.price = this.$numberFormatter.formatMoney(price);
          }
        }
      });
    },
    saveAttachment(data = null) {
      let postData = {}
      if (data) {
        postData = {
          stock_order_code: this.stock_in.stock_order_code,
          stock_order_details: [{
            id: data.id,
            memo: data.memo
          }]
        }
      }else {
        postData = {
          stock_order_code: this.stock_in.stock_order_code,
          attachment: this.stock_in.attachment
        }
      }
      this.$store.dispatch("fullscreenLoading");
      StockIns.update(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (data) {
                this.editMemoData = null;
              } else {
                this.edit_attachment = false;
              }
              this.$snackbar.success(i18n.t("StockOrderOUT.Messages.saveAttachmentSuccess"));
              this.getStockOutsFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
      ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      );
    },
    setEditMemoFlg(data) {
      if (this.editMemoData && this.editMemoData.id != data.id) {
        // 未保存且切换待修改单据时
        this.stock_in_details = this.stock_in_details.map((detail) => {
          if (detail.id == this.editMemoData.id) {
            detail.memo = this.editMemoData.memo;
          }
          return detail;
        })
      }
      this.editMemoData = Object.assign({}, data);
    },
  },

  watch: {
    mode: {
      handler() {
        this.edit_attachment = false
        if (this.isNew) {
          this.stock_in = {
            actual_date: this.$datetimeUtils.formatTime(new Date()),
            stock_order_details: [],
            order_num_count: 0,
            confirm_num_count: 0,
            detail_length: 0,
          };
        } else if (this.stockInitialize) {
          if (this.$route.query.stock_id) {
            this.stock_in = {
              type: 21,
              stock_id: this.stock_id,
              actual_date: this.$datetimeUtils.formatTime(new Date()),
              stock_order_details: [],
              order_num_count: 0,
              confirm_num_count: 0,
              detail_length: 0,
            };
            Stocks.fetchOne(this.$route.query.stock_id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stock_in = Object.assign({}, this.stock_in, {
                    stock: response.data.stock,
                  });
                }
              }.bind(this)
            );
          }
        } else if (this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    stockSelected: {
      handler() {
        if (this.stockSelected) {
          this.stock_in.stock_id = this.stockSelected.id;
        }
      },
    },
    supplierSelected: {
      handler() {
        if (this.supplierSelected) {
          this.stock_in.supplier_id = this.supplierSelected.id;
          let material_ids = [];
          if (
            this.stock_in_details.length > 0 &&
            this.stock_in.stock_id &&
            this.stock_in.type == 11
          ) {
            material_ids = this.stock_in_details.map((d) => d.material_id);
            let postData = {
              stock_id: this.stock_in.stock_id,
              readonly: 0,
              in_type: this.stock_in.type,
              material_ids: material_ids,
              supplier_id: this.stock_in.supplier_id,
            };
            if (this.stock_in.type == 1) {
              postData.return_flg = 1;
            }
            StockMaterials.fetchAllForSelect(postData).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stock_in_details.forEach((d) => {
                    d.price = response.data.materials.find(
                      (v) => v.material_id == d.material_id
                    ).in_price;
                  });
                }
              }.bind(this)
            );
          }
        }
      },
    },
    shopSelected: {
      handler() {
        if (this.shopSelected) {
          this.stock_in.shop_id = this.shopSelected.id;
        }
      },
    },
    stock_in: {
      handler() {
        this.stock_in_details =
          this.stock_in && this.stock_in.stock_order_details
            ? this.stock_in.stock_order_details
            : [];
      },
    },
    stock_in_details: {
      deep: true,
      handler() {
        //计算小计
        var total = 0;
        this.stock_in.confirm_num_count = 0;
        this.stock_in_details.forEach((detail) => {
          this.stock_in.confirm_num_count += detail.confirm_num;
          let order_num = detail.order_num ? detail.order_num : 0;
          let confirm_num = detail.confirm_num ? detail.confirm_num : 0;
          if (
            this.stock_in.type == 11 &&
            this.settings &&
            this.settings.purchase_subtotal == 1
          ) {
            if (this.isNew) {
              if (
                  order_num != 0 ||
                  detail.order_num_2 != 0 ||
                  detail.order_num_3 != 0
              ) {
                if (order_num) {
                  detail.price = this.$numberFormatter.formatMoney(
                      parseFloat(Number(detail.total) / Number(order_num)).toFixed(
                          4
                      )
                  );
                } else {
                  detail.price = 0;
                }
                if (detail.order_num_2) {
                  detail.price_2 = this.$numberFormatter.formatMoney(
                      parseFloat(
                          Number(detail.total_2) / Number(detail.order_num_2)
                      ).toFixed(2)
                  );
                } else {
                  detail.price_2 = 0;
                }
                if (detail.order_num_3) {
                  detail.price_3 = this.$numberFormatter.formatMoney(
                      parseFloat(
                          Number(detail.total_3) / Number(detail.order_num_3)
                      ).toFixed(2)
                  );
                } else {
                  detail.price_3 = 0;
                }
              } else {
                detail.price = 0;
                detail.price_2 = 0;
                detail.price_3 = 0;
              }
            }else {
              if (order_num || confirm_num) {
                detail.price = this.$numberFormatter.formatMoney(parseFloat(Number(detail.total) / Number(confirm_num ? confirm_num :order_num)).toFixed(4));
              } else {
                detail.price = 0;
              }
            }

            total +=
              (detail.total ? Number(detail.total) : 0) +
              (detail.total_2 ? Number(detail.total_2) : 0) +
              (detail.total_3 ? Number(detail.total_3) : 0);
          } else if (this.stock_in.type == 4) {
            total += Number(detail.total);
          } else if (this.isStockIN) {
            detail.total = this.$numberFormatter.formatMoneyFloor(
                parseFloat(Number(confirm_num ? confirm_num : 0) * Number(detail.price)).toFixed(4)
            );
            total += Number(detail.total)
          } else {
            detail.total = this.$numberFormatter.formatMoneyFloor(
              parseFloat(
                Number((confirm_num ? confirm_num: order_num ? order_num : 0)) * Number(detail.price)
              ).toFixed(4)
            );
            detail.total_2 = this.$numberFormatter.formatMoneyFloor(
              parseFloat(
                Number(detail.order_num_2 ? detail.order_num_2 : 0) *
                  Number(detail.price)
              ).toFixed(4)
            );
            detail.total_3 = this.$numberFormatter.formatMoneyFloor(
              parseFloat(
                Number(detail.order_num_3 ? detail.order_num_3 : 0) *
                  Number(detail.price)
              ).toFixed(4)
            );

            total +=
              Number(detail.total) +
              Number(detail.total_2) +
              Number(detail.total_3);
          }
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.material.bestbefore) &&
            detail.production_date &&
            !detail.expired_date
          ) {
            detail.expired_date = new Date(
              new Date(detail.production_date).getTime() +
                Number(detail.material.bestbefore) * 24 * 3600 * 1000
            )
              .toISOString()
              .substr(0, 10);
          }

          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.material.bestbefore) &&
            detail.production_date_2 &&
            !detail.expired_date_2
          ) {
            detail.expired_date_2 = new Date(
              new Date(detail.production_date_2).getTime() +
                Number(detail.material.bestbefore) * 24 * 3600 * 1000
            )
              .toISOString()
              .substr(0, 10);
          }

          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.material.bestbefore) &&
            detail.production_date_3 &&
            !detail.expired_date_3
          ) {
            detail.expired_date_3 = new Date(
              new Date(detail.production_date_3).getTime() +
                Number(detail.material.bestbefore) * 24 * 3600 * 1000
            )
              .toISOString()
              .substr(0, 10);
          }
          // // 单位切换，修改单价
          // if (this.isNew || detail.new) {
          //   // default_standard_detail_id用来判断单位是否改变
          //   if (
          //     detail.standard_detail_id != detail.default_standard_detail_id
          //   ) {
          //     var rate1 = detail.standard_details.find(
          //       (r) => r.id == detail.default_standard_detail_id
          //     ).rate; //切换前的单位rate
          //     var rate2 = detail.standard_details.find(
          //       (r) => r.id == detail.standard_detail_id
          //     ).rate; //切换后的单位rate
          //     // 计算价格
          //     detail.price = this.$numberFormatter.formatMoney(
          //       (detail.price / rate1) * rate2
          //     );
          //     detail.default_standard_detail_id = detail.standard_detail_id;
          //   }
          // }
        });
        this.total = total;
      },
    },
    selectMaterial: {
      handler() {
        if (this.selectMaterial && this.selectMaterial.id) {
          if (!this.stock_in.type) {
            snackbar.info(i18n.t("StockOrderIN.Messages.stock_in_type_error"));
            this.selectMaterial = null;
            return;
          }
          let postData = {
            stock_id: this.stock_in.stock_id,
            readonly: 0,
            in_type: this.stock_in.type,
            material_ids: [this.selectMaterial.material_id],
          };
          if (this.stock_in.type == 1) {
            postData.return_flg = 1;
          }
          if (this.stock_in.type == 11 && this.stock_in.supplier_id) {
            postData.supplier_id = this.stock_in.supplier_id;
          }

          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterial = response.data.materials[0];
              }
            }.bind(this)
          );
        }
      },
    },
    selectMaterials: {
      handler() {
        if (this.selectMaterials && this.selectMaterials.length) {
          if (!this.stock_in.type) {
            snackbar.info(i18n.t("StockOrderIN.Messages.stock_in_type_error"));
            this.selectMaterials = [];
            return;
          }
          let postData = {
            stock_id: this.stock_in.stock_id,
            readonly: 0,
            in_type: this.stock_in.type,
            material_ids: this.selectMaterials.map(
              (selectMaterial) => selectMaterial.material_id
            ),
          };
          if (this.stock_in.type == 11 && this.stock_in.supplier_id) {
            postData.supplier_id = this.stock_in.supplier_id;
          }
          if (this.stock_in.type == 1) {
            postData.return_flg = 1;
          }

          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterials(response.data.materials, false);
              }
            }.bind(this)
          );
        }
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          //获取库存单位
          var standard_detail = this.addMaterial.standard_detail_id
            ? this.addMaterial.standard_details.find(
                (standard_detail) =>
                  standard_detail.id == this.addMaterial.standard_detail_id
              )
            : "";

          //判断库存单位是否是默认单位
          var current_quantity_with_unit = "";
          var current_count_with_unit = "";
          if (!standard_detail.default_flg) {
            var standard_detail_default =
              this.addMaterial.standard_details.find(
                (standard_detail) => standard_detail.default_flg == 1
              );
            current_count_with_unit = i18n.t("Stock.stockQuantity", [
              this.addMaterial.current_count,
              standard_detail_default.unit,
            ]);
            //库存单位与默认单位转换
            if (this.addMaterial.current_count) {
              //库存量不为零
              //大单位取整
              var current_quantity_int = parseInt(
                this.addMaterial.current_count / standard_detail.rate
              );
              //小单位取余
              if (this.addMaterial.current_count % standard_detail.rate) {
                var current_quantity_decimal =
                  this.addMaterial.current_count % standard_detail.rate;
                current_quantity_with_unit = i18n.t(
                  "Stock.stockQuantityWithMultipleUnits",
                  [
                    current_quantity_int,
                    standard_detail.unit,
                    current_quantity_decimal,
                    standard_detail_default.unit,
                  ]
                );
              } else {
                current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
                  current_quantity_int,
                  standard_detail.unit,
                ]);
              }
            } else {
              //库存量为零
              current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
                this.addMaterial.current_count,
                standard_detail.unit,
              ]);
            }
          } else {
            current_quantity_with_unit = i18n.t("Stock.stockQuantity", [
              this.addMaterial.current_count,
              standard_detail.unit,
            ]);
          }
          let price =
            this.stock_in.type == 11
              ? standard_detail.in_price
              : standard_detail.supply_price
              ? standard_detail.supply_price
              : 0;
          if (
            this.stock_in.type == 1 ||
            this.stock_in.type == 12 ||
            this.stock_in.type == 13
          ) {
            price = standard_detail.stock_in_price;
          }
          this.stock_in_details.push({
            new: this.stock_in_details.length + 1,
            key: this.stock_in_details.length + 1,
            stock_out_id: this.stock_in.id,
            category_name: this.addMaterial.category_name,
            material_id: this.addMaterial.material_id,
            material_code: this.addMaterial.material_code,
            material_name: this.addMaterial.material_name,
            unit: this.addMaterial.unit,
            standard_detail_unit: standard_detail.unit,
            current_count_with_unit: current_count_with_unit,
            current_quantity_with_unit: current_quantity_with_unit,
            price: this.$numberFormatter.formatMoney(price),
            memo: null,
            standard_details: this.addMaterial.standard_details,
            material: this.addMaterial,
            standard_name: this.addMaterial.standard
              ? this.addMaterial.standard.name
              : "",
            standard_detail_id: this.addMaterial.standard_detail_id,
            default_standard_detail_id: this.addMaterial.standard_detail_id, //判断单位是否切换，不提交
          });
          this.selectMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          };
          this.addMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    currentItem: {
      deep: true,
      handler() {
        this.stock_in_details.forEach((detail) => {
          if (detail.id == this.currentItem.id) {
            detail.qualify_report_img = this.currentItem.qualify_report_img
              ? this.currentItem.qualify_report_img
              : [];
          }
        });
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.stock_in.img ? this.stock_in.img : [];
        }
      },
    },
  },
};
</script>